import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { listLinkedAccounts } from '@wix/ambassador-asa-linked-account-v1-linked-account/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { LinkedAccountClientBase } from './LinkedAccountClientBase';
export class LinkedAccountClient extends HttpBaseClient(LinkedAccountClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "listLinkedAccountsImpl", listLinkedAccounts);
  }
}
//# sourceMappingURL=LinkedAccountClientHttp.js.map